import Banner from 'common/components/banner/banner';
import * as React from 'react';

import {
  Button,
  ButtonTypes,
  PrimaryButton,
} from 'common/components/controls/button/button';
import { BusinessBlue500 } from 'common/lib/colors/index';
import { forNamespace } from 'common/lib/util/i18n';
import InlineLink from '../billable-guests-alert/inline-link';
import styles from './notice-banner.less';

interface NoticeBannerProps {
  children: React.ReactNode;
  onDismiss?: () => void;
  inline?: boolean;
  learnMoreUrl?: string;
  actionButton?: {
    text: string;
    onClick: () => void;
  };
}

const learnMore = forNamespace()('learn more button');

const NoticeBanner = ({
  children,
  onDismiss,
  inline,
  actionButton,
  learnMoreUrl,
}: NoticeBannerProps) => {
  return (
    <Banner
      onDismiss={onDismiss}
      bannerColor={BusinessBlue500}
      useLightText
      roundedCorners={inline}
      inlinePadding={inline}
    >
      <div className={styles.noticeBannerContainer}>
        <div className={styles.textContent}>
          {children}{' '}
          {learnMoreUrl &&
            inline && <InlineLink text={learnMore} href={learnMoreUrl} />}
        </div>
        {learnMoreUrl &&
          !inline && (
            <div className={styles.learnMoreButton}>
              <Button
                onClick={() => window.open(learnMoreUrl, '_blank')}
                type={ButtonTypes.LINKBUTTON}
                role="link"
              >
                {learnMore}
              </Button>
            </div>
          )}
        {actionButton &&
          !inline &&
          !learnMoreUrl && (
            <div className={styles.learnMoreButton}>
              <PrimaryButton onClick={actionButton.onClick} role="link">
                {actionButton.text}
              </PrimaryButton>
            </div>
          )}
      </div>
    </Banner>
  );
};

export default NoticeBanner;



// WEBPACK FOOTER //
// ./app/common/components/notice-banner/notice-banner.tsx